import { QuotePriceAndExpireDate } from '@/components/shared';
import { categories } from '@/constants/item';
import type { IOrder } from '@/types';
import { Flex, Box, Text, Link } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

interface IShipmentCardProps {
  shipment: IOrder | undefined;
}

export const ShipmentCard: React.FC<IShipmentCardProps> = (props): JSX.Element => {
  const { t } = useTranslation();

  const { shipment } = props;

  let date = '';

  if (shipment?.createdAt) {
    date = new Date(shipment.createdAt).toLocaleDateString('it-IT').replaceAll('/', '.');
  }

  let itemCategoryLabel: string | undefined;

  if (shipment?.item.category) {
    const itemCategoryElement = categories.find((cat) => cat.id === shipment.item.category);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    itemCategoryLabel = itemCategoryElement?.label;
  }

  const isArchived =
    shipment?.status === 'SHIPMENT_CANCELED' || shipment?.status === 'SHIPMENT_DELIVERED';

  //TODO[SHIPMENTS]Refactor methods

  return (
    <Flex
      alignItems={{ base: 'flex-start', md: 'center' }}
      bg="white"
      boxShadow="0 0 8px 2px rgba(53,60,79, 0.1)"
      color={isArchived ? 'brand.gray' : 'unset'}
      direction={{ base: 'column', md: 'row' }}
      gap={10}
      justifyContent="flex-start"
      minH="167px"
      p={8}
      w="full"
    >
      <Flex direction="column" gap={2} w={{ base: '100%', md: '25%' }}>
        <Text fontSize={{ base: '24px', md: '18px' }}>
          {t('ACCOUNT.SHIPMENTS.SHIPMENT_CARD.SHIPMENT_TITLE')}
          <br />
          <Text as="span" fontSize="18px">
            {shipment?.id}
          </Text>
        </Text>
        <Text>
          {t('ACCOUNT.SHIPMENTS.SHIPMENT_CARD.OF')} {date}
        </Text>
        {shipment?.id && !isArchived && (
          <NavLink to={`/details/${shipment.id}`}>
            <Link as="span" color="brand.red.light">
              {t('ACCOUNT.SHIPMENTS.SHIPMENT_CARD.SHOW_DETAILS')}
            </Link>
          </NavLink>
        )}
      </Flex>
      <Flex direction="column" w={{ base: '100%', md: '50%' }}>
        <Text fontSize="h4" fontWeight="bold" textTransform="capitalize">
          {shipment?.item.name}
        </Text>
        <Text>{itemCategoryLabel && t(itemCategoryLabel)}</Text>
      </Flex>
      <Box minW={150} textAlign={{ base: 'left', md: 'right' }} w="20%">
        {shipment && <QuotePriceAndExpireDate quoteStatus={shipment.status} />}
      </Box>
    </Flex>
  );
};
